import React, {useReducer} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {
  setWizardPopupDisabledScenes,
  setWizardPopupItem,
  setWizardPopupOpened
} from "../wizardActions";
import WizardPopupSaveButton from "./WizardPopupSaveButton";
import {WIZARD_POPUP_TYPES} from "../wizardReducer";
import WizardPopupSceneSelection from "./WizardPopupSceneSelection/WizardPopupSceneSelection";
import {defaultWizardItem} from "../WizardItem/wizardItemInterface";
import WizardPopupEditGroup from "./WizardPopupEditGroup/WizardPopupEditGroup";
import WizardPopupContext, {wizardPopupContextReducer} from "./WizardPopupContext";
import WizardPopupFeaturesExclusion from "./WizardPopupFeaturesExclusion/WizardPopupFeaturesExclusion";
import WizardPopupFiltersExclusion from "./WizardPopupFiltersExclusion/WizardPopupFiltersExclusion";
import WizardClonePopupContent from "./WizardClonePopup/WizardClonePopupContent";
import WizardClonePopupTitle from "./WizardClonePopup/WizardClonePopupTitle";
import WizardClonePopupSaveButton from "./WizardClonePopup/WizardClonePopupSaveButton";
import WizardPopupInputsGroup, {
  allInputs,
  createReorderedInputsList
} from "./WizardPopupInputGroup/WizardPopupInputsGroup";
import WizardPopupEditGroupViewType from "./WizardPopupEditGroup/WizardPopupEditGroupViewType";
import WizardPopupItemToggles from "./WizardPopupItemToggles/WizardPopupItemToggles";

const WizardPopup = (props) => {

  const {setWizardPopupOpened, wizardPopupType, wizardPopupOpened, setWizardPopupItem, wizardPopupItem, wizardPopupGroup,
     setWizardPopupDisabledScenes, wizardCloneLogic} = props;

  if (!wizardPopupOpened) {
    return null
  }

  const [wizardPopupState, wizardPopupDispatch] = useReducer(wizardPopupContextReducer, {
    title: wizardPopupGroup ? wizardPopupGroup.title : "",
    description: wizardPopupGroup ? wizardPopupGroup.description : "",
    featuresExcluded: wizardPopupGroup ? wizardPopupGroup.featuresExcluded : [],
    featuresIncluded: wizardPopupGroup ? wizardPopupGroup.featuresIncluded || [] : [],
    useIncluded: wizardPopupGroup ? wizardPopupGroup.useIncluded : false,
    filtersExcluded: wizardPopupGroup ? wizardPopupGroup.filtersExcluded : [],
    searchText: "",
    productCartTitle: wizardPopupGroup ? wizardPopupGroup.productCartTitle : "",
    productCartDescription: wizardPopupGroup ? wizardPopupGroup.productCartDescription : "",
    uploadedImageUrl: wizardPopupGroup ? wizardPopupGroup.uploadedImageUrl : "",
    customImageUrl: wizardPopupGroup ? wizardPopupGroup.customImageUrl : "",
    notRequired: wizardPopupGroup ? wizardPopupGroup.notRequired : false,
    selectedFabricators: [],
    mode: "target",
    multipleAddToCart: wizardPopupGroup ? wizardPopupGroup.multipleAddToCart : false,
    separateSqftLabel: wizardPopupGroup ? wizardPopupGroup.separateSqftLabel : false,
    isCenterIslandGroup: wizardPopupGroup ? wizardPopupGroup.isCenterIslandGroup : false,
    hideInCartAndReceipt: wizardPopupGroup ? wizardPopupGroup.hideInCartAndReceipt : false,
    skipProductInfo: wizardPopupGroup ? wizardPopupGroup.skipProductInfo : false,
    hidePriceNoCart: wizardPopupGroup ? wizardPopupGroup.hidePriceNoCart : false,
    skipLockDontApply: wizardPopupGroup ? wizardPopupGroup.skipLockDontApply : false,
    dontMatchFeaturesBySku: wizardPopupGroup ? wizardPopupGroup.dontMatchFeaturesBySku : false,
    matchAllDisabled: wizardPopupGroup ? wizardPopupGroup.matchAllDisabled : false,
    wizardGroupIcon: wizardPopupGroup ? wizardPopupGroup.wizardGroupIcon : "",
    leadStep: wizardPopupGroup ? wizardPopupGroup.leadStep : "",
    inputFields: wizardPopupGroup && wizardPopupGroup.inputFields ? createReorderedInputsList(wizardPopupGroup.inputFields) : [...allInputs],
    headerTitle: wizardPopupGroup ? wizardPopupGroup.headerTitle : "",
    headerSubTitle: wizardPopupGroup ? wizardPopupGroup.headerSubTitle : "",
    viewType: wizardPopupGroup ? wizardPopupGroup.viewType || 3 : 3,
    visibleInVisualizers: wizardPopupGroup ? wizardPopupGroup.visibleInVisualizers || [] : [],
    skipStartStep: wizardPopupItem ? wizardPopupItem.skipStartStep || false : false,
    clickOnLogic: wizardPopupGroup ? wizardPopupGroup.clickOnLogic : null,
  });

  const closePopup = () => {
    setWizardPopupOpened(false);
    setWizardPopupDisabledScenes([]); // clear current scenes
    setWizardPopupItem(defaultWizardItem); // clear existing values
  };

  const getContent = () => {
    switch (wizardPopupType) {
      case WIZARD_POPUP_TYPES.sceneSelection:
        return <WizardPopupSceneSelection/>
      case WIZARD_POPUP_TYPES.editGroup:
      case WIZARD_POPUP_TYPES.start:
        return <WizardPopupEditGroup/>
      case WIZARD_POPUP_TYPES.featuresExclusion:
        return <WizardPopupFeaturesExclusion/>
      case WIZARD_POPUP_TYPES.filtersExclusion:
        return <WizardPopupFiltersExclusion/>
      case WIZARD_POPUP_TYPES.cloneWizard:
        return <WizardClonePopupContent/>
      case WIZARD_POPUP_TYPES.inputsSetup:
        return <WizardPopupInputsGroup/>
      case WIZARD_POPUP_TYPES.editItemToggles:
        return <WizardPopupItemToggles/>
      default:
        return null
    }
  }

  console.log("wizardPopupState", wizardPopupState);

  return (
    <WizardPopupContext.Provider value={{wizardPopupState, wizardPopupDispatch}} >
      <div className={"ui-popup ui-popup--wizard ui-popup--wizard--" + wizardPopupType}>
        {wizardPopupType === WIZARD_POPUP_TYPES.editGroup ? (
          <WizardPopupEditGroupViewType/>
        ) : null}
        <button className="ui-popup-header__close" onClick={closePopup}/>
        {wizardPopupType === WIZARD_POPUP_TYPES.sceneSelection ? (
          <div className="ui-popup__header">
          <span className="ui-popup__header-title">
            <FormattedMessage id="wizard.popup.sceneSelection"/>
            {/*    {wizardPopupItem && wizardPopupItem.name ? " / " + wizardPopupItem.name : null}*/}
            {/*    {wizardPopupGroup ? " / " + (wizardPopupGroup.customDisplayName || wizardPopupGroup.groupName) : null}*/}
          </span>
          </div>
        ) : null}
        {wizardPopupType === WIZARD_POPUP_TYPES.cloneWizard ? <WizardClonePopupTitle/> : null}
        <div className="ui-popup-body ui-popup-body--small">
          {getContent()}
        </div>
        <div className="ui-popup-footer">
          {wizardCloneLogic.visible ? null : (
            <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--blue" onClick={closePopup}>
              <FormattedMessage id="messageBox.buttons.cancel"/>
            </button>
          )}
          {wizardPopupType === WIZARD_POPUP_TYPES.cloneWizard ? <WizardClonePopupSaveButton/> : <WizardPopupSaveButton/>}
        </div>
      </div>
    </WizardPopupContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupOpened, wizardPopupType, wizardPopupGroup, wizardPopupItem, wizardCloneLogic} = store.wizardState;
  return {
    wizardPopupOpened,
    wizardPopupType,
    wizardPopupGroup,
    wizardPopupItem,
    wizardCloneLogic,
  };
};

const mapDispatchToProps = {
  setWizardPopupOpened,
  setWizardPopupItem,
  setWizardPopupDisabledScenes,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(WizardPopup)
)
